"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"rotating":"CircularProgress_q8nQr","tmhk-circular-progress-rotating":"CircularProgress_U7h90"};
tokens._getCss = function () {return `/* imported from CircularProgress.css */ @keyframes CircularProgress_U7h90 { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .CircularProgress_q8nQr { animation: CircularProgress_U7h90 550ms linear infinite; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/src/svg/sync/CircularProgress_css.js"};
exports["default"] = tokens;